/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CharactersInputs */

const en_characters = /** @type {(inputs: CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Characters`)
};

const fr_characters = /** @type {(inputs: CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caractères`)
};

const de_characters = /** @type {(inputs: CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charaktere`)
};

const it_characters = /** @type {(inputs: CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caratteri`)
};

const ru_characters = /** @type {(inputs: CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Персонажи`)
};

const es_characters = /** @type {(inputs: CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personajes`)
};

const zh_cn2_characters = /** @type {(inputs: CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人物`)
};

const ja_characters = /** @type {(inputs: CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャラクター`)
};

const hi_characters = /** @type {(inputs: CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पात्रों`)
};

const pt_pt2_characters = /** @type {(inputs: CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personagens`)
};

/**
* | output |
* | --- |
* | "Characters" |
*
* @param {CharactersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const characters = /** @type {((inputs?: CharactersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CharactersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_characters(inputs)
	if (locale === "de") return de_characters(inputs)
	if (locale === "it") return it_characters(inputs)
	if (locale === "ru") return ru_characters(inputs)
	if (locale === "es") return es_characters(inputs)
	if (locale === "zh-CN") return zh_cn2_characters(inputs)
	if (locale === "ja") return ja_characters(inputs)
	if (locale === "hi") return hi_characters(inputs)
	if (locale === "pt-PT") return pt_pt2_characters(inputs)
	return en_characters(inputs)
});